
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { QrCodeObject } from "@/models/QrCodeObject";
import getReportService from "@/services/ReportService";

import CheckBox from "@/components/Checkbox.vue";
import CloseButton from "@/components/buttons/CloseButton.vue";
import { ShortlinkReportPayload } from "@/models/Shortlink";

export default {
    name: "ReportContentPopin",
    components: { CheckBox, CloseButton },
    emits: ["close"],
    props: {
        qrcodeObject: {
            type: Object,
            required: true
        },
        videoUrl: String
    },
    setup(props: { qrcodeObject: QrCodeObject; videoUrl: string }, { emit }) {
        const store = useStore();

        const emailRegex = /^[a-z-_.0-9]+@([a-z-_0-9]+\.)+[a-z-_0-9]{2,}$/;
        const { t } = useI18n({ useScope: "global" });
        const reportSent = ref(false);
        const selectedReason = ref(null as number | null);
        const availableReasons = [
            "HATE",
            "NUDITY_SEX",
            "ANIMAL_CRUELTY",
            "SUICIDE_SELF_INJURY",
            "BULLYING",
            "FAKE_NEWS",
            "VIOLENCE",
            "SCAM",
            "SALE_ILLEGAL",
            "INTELLECTUAL_VIOLATION",
            "CHILDREN_SAFETY"
        ];
        const keepUserInformed = ref(false);
        const firstName = ref("");
        const lastName = ref("");
        const email = ref("");
        const message = ref("");

        const error = ref("");

        function selectReason(reason: number) {
            selectedReason.value = reason;
        }

        async function submitForm() {
            error.value = "";

            if (keepUserInformed.value) {
                if (!email.value.length) {
                    error.value = t("report.errors.emailFieldRequiredField");
                    return;
                } else if (!emailRegex.test(email.value)) {
                    error.value = t("report.errors.invalidEmail");
                    return;
                }
            }

            const properties: ShortlinkReportPayload = {
                shortlinkId: props.qrcodeObject.shortlink.id,
                shortlinkReportTypeId: selectedReason.value,
                email: email.value.length ? email.value : undefined,
                firstName: firstName.value.length ? firstName.value : undefined,
                lastName: lastName.value.length ? lastName.value : undefined,
                message: message.value.length ? message.value : undefined
            };

            const data = await getReportService().createReport(properties);

            if (data?.status > 200 && data?.status < 300) {
                this.reportSent = true;
                store.dispatch("qrcode/load", props.qrcodeObject.shortlink.publicCryptoId);
            } else if (data?.code?.length) {
                error.value = t("report.errors." + data.code);
            } else {
                error.value = t("report.errors.unknownError");
            }
        }

        function close() {
            emit("close");
        }

        return {
            submitForm,
            close,
            selectReason,
            availableReasons,
            error,
            selectedReason,
            keepUserInformed,
            firstName,
            lastName,
            email,
            message,
            reportSent
        };
    }
};
